import * as React from "react"
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil"
import {
  allReplysIdsAtom,
  chatCountAtom,
  chatIdsSelector,
  chatIsReadAtom,
  chatListSelector,
  prevChatCountAtom
} from "../../../recoil/atoms/chats"
import layoutStates from "../../../recoil/atoms/layout"

const HandleChatCount = () => {
  const isChatTab = useRecoilValue(layoutStates.isChatTab)
  // const allChatIds = useRecoilValue(chatIdsSelector) as string[]
  // const allReplyIds = useRecoilValue(allReplysIdsAtom)
  const chatList = useRecoilValue(chatListSelector)
  const setChatIsRead = useSetRecoilState(chatIsReadAtom)
  const setChatCount = useSetRecoilState(chatCountAtom)
  const [prevChatCount, setPrevChatCount] = useRecoilState(prevChatCountAtom)
  const prevChatCountRef = React.useRef(prevChatCount)

  React.useEffect(() => {
    prevChatCountRef.current = prevChatCount
  }, [prevChatCount])

  let chatCount = React.useMemo(() => chatList.length, [chatList.length])
  // let chatCount = React.useMemo(
  //   () => allChatIds.length + allReplyIds.length,
  //   [allChatIds.length, allReplyIds.length]
  // )

  React.useEffect(() => {
    setChatCount(chatCount)
    if (prevChatCountRef.current === 0 && chatCount >= 0) {
      setChatIsRead(false)
    }
    if (chatCount === 0) {
      setChatIsRead(true)
    }
    // prevChatCountRef.current = chatCount
    setPrevChatCount(chatCount)
  }, [chatCount, setChatIsRead, setChatCount, setPrevChatCount])

  React.useEffect(() => {
    if (!isChatTab) {
      if (prevChatCountRef.current < chatCount) {
        setChatIsRead(false)
      }
    }
  }, [isChatTab, chatCount, setChatIsRead])

  return null
}

export default React.memo(HandleChatCount)
